/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  formControl,
  formInputText,
  formControlError,
} from '@assets/styles/formStyles';
import { INPUT_HEIGHT } from '@/constants';
import SociollaText from '@components/sociolla/SociollaText';
import FormArrow from '@components/form/common/FormArrow';
import PropTypes from 'prop-types';

const propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  hasError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  editable: PropTypes.bool,
  inputContainerStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

const defaultProps = {
  value: '',
  placeholder: '',
  hasError: false,
  editable: true,
  inputContainerStyle: {},
};

const FormInputContainer = (props) => {
  const { value, placeholder, hasError, inputContainerStyle, editable } = props;

  return (
    <View
      style={[
        formControl,
        inputContainerStyle,
        hasError ? formControlError : {},
        !editable ? { backgroundColor: '#ebebeb' } : {},
        styles.container,
      ]}>
      {placeholder && !value ? (
        <SociollaText style={[formInputText, styles.placeholder]}>
          {placeholder}
        </SociollaText>
      ) : value ? (
        <SociollaText style={{ ...formInputText, alignSelf: 'flex-start' }}>
          {value}
        </SociollaText>
      ) : (
        false
      )}
      <FormArrow {...props} right={10} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'left',
    height: INPUT_HEIGHT,
  },
  placeholder: {
    alignSelf: 'flex-start',
    color: '#90919b',
  },
});

FormInputContainer.propTypes = propTypes;
FormInputContainer.defaultProps = defaultProps;

export default React.memo(FormInputContainer, (prev, next) => prev == next);
